import {
  PLAN_ID_ENTERPRISE,
  PLAN_ID_ORGANIZATION,
  PLAN_ID_PROFESSIONAL,
} from "../../helper/pricingHandoff";

export const BILLING_MONTHLY = "monthly";
export const BILLING_ANNUAL = "annual";

/**
 * Subscription plans for the post-onboarding pricing modal.
 * Feature copy mirrors https://www.alphasearch.io/plans-pricing
 */
export const PRICING_PLANS = [
  {
    id: PLAN_ID_PROFESSIONAL,
    label: "Professional",
    description: "Essential deal-sourcing tools for individual researchers.",
    featuresIntro: "Includes:",
    features: [
      "Private Company Database",
      "Email Enrichment Waterfall",
      "LLM Enrichment",
      "Downloadable to Excel",
      "Email and Phone Support",
    ],
  },
  {
    id: PLAN_ID_ORGANIZATION,
    label: "Organization",
    description: "Built for growing teams collaborating on deal sourcing.",
    featuresIntro: "Includes:",
    features: [
      "With access to 3 Logins",
      "Private Company Database",
      "Email Waterfall Enrichment",
      "LLM Enrichment",
      "Downloadable to Excel",
      "Email and Phone support",
    ],
  },
  {
    id: PLAN_ID_ENTERPRISE,
    label: "Enterprise",
    description: "Advanced capabilities for scale across the firm.",
    featuresIntro: "Includes:",
    features: [
      "All Professional Features",
      "API Access",
      "CRM API Integrations",
      "Remote or On-site training",
      "Free Workflow Automation Audits on Acquisitions",
      "SLA Guarantees",
    ],
    footnote:
      "Negotiable based on API usage/limits, firm headcount, pricing available upon request.",
  },
];

export const getPlanById = (planId) =>
  PRICING_PLANS.find((plan) => plan.id === planId) || null;

export function getCatalogPrice(plan, billingCycle) {
  return plan.prices?.find((price) => price.billing_cycle === billingCycle
    && Number.isInteger(price.price_cents) && price.price_cents > 0
    && price.currency === "usd") || null;
}

export const formatUsd = (amount) => `US$${Number(amount).toLocaleString("en-US", {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
})}`;
export const isAnnualBilling = (billingCycle) => billingCycle === BILLING_ANNUAL;
export const getPlanPrice = (plan, billingCycle) => {
  const price = getCatalogPrice(plan, billingCycle);
  return price ? price.price_cents / 100 : null;
};
export const getPlanBillingLabel = (billingCycle) => isAnnualBilling(billingCycle) ? "/ year" : "/ month";
export const getPlanPriceLabel = (plan, billingCycle) => {
  const price = getPlanPrice(plan, billingCycle);
  return price === null ? "Price unavailable" : formatUsd(price);
};
export const getAfterTrialPriceLabel = (plan, billingCycle) =>
  `${getPlanPriceLabel(plan, billingCycle)} ${getPlanBillingLabel(billingCycle)}`;

export const getPlanFeatures = (plan, billingCycle) => {
  const features = plan.features.filter((feature) => !feature.startsWith("With access to"));
  if (Number.isInteger(plan.includedSeats) && plan.includedSeats > 0) {
    features.unshift(`With access to ${plan.includedSeats} Login${plan.includedSeats === 1 ? "" : "s"}`);
  }
  const seat = getCatalogPrice({prices: plan.seatPrices}, billingCycle);
  if (seat && plan.id === PLAN_ID_ORGANIZATION) {
    features.splice(1, 0, `${formatUsd(seat.price_cents / 100)}${isAnnualBilling(billingCycle) ? "/year" : "/month"} each additional seat`);
  }
  return features;
};
